import { useEffect, useState } from "react";
import { IconPin } from "../../HeroIcons";
import PrimaryButton from "../ui/PrimaryButton";
import VisitMap from "../ui/VisitMap";
import {
  IconClock,
  IconPhone,
  IconMail,
  IconInstagram,
  IconFacebook,
} from "../ui/VisitIcons";

async function copyText(value) {
  if (navigator.clipboard?.writeText) {
    await navigator.clipboard.writeText(value);
    return;
  }
  const input = document.createElement("textarea");
  input.value = value;
  input.setAttribute("readonly", "");
  input.style.position = "fixed";
  input.style.opacity = "0";
  document.body.appendChild(input);
  input.select();
  document.execCommand("copy");
  document.body.removeChild(input);
}

function VisitUsSection({ t, onBookTable }) {
  const [copied, setCopied] = useState(false);
  const phoneHref = `tel:${t.phoneValue.replace(/\s/g, "")}`;

  useEffect(() => {
    if (!copied) return undefined;
    const timer = window.setTimeout(() => setCopied(false), 2000);
    return () => window.clearTimeout(timer);
  }, [copied]);

  async function handleCopyEmail() {
    try {
      await copyText(t.emailValue);
      setCopied(true);
    } catch {
      setCopied(false);
    }
  }

  return (
    <section
      className="landing-section visit-us-section"
      id="contact"
      data-nav-section="contact"
    >
      <div className="container">
        <div className="visit-us-grid">
          <div className="visit-us-block visit-us-block--info">
            <h2 className="visit-us-title">{t.title}</h2>

            <ul className="visit-us-details">
              <li>
                <IconPin className="visit-icon" />
                <a
                  href="https://maps.app.goo.gl/d2heEbWpifjWDCNJ9"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {t.address}
                </a>
              </li>
              <li className="visit-us-hours">
                <IconClock className="visit-icon" />
                <span>{t.hours}</span>
              </li>
            </ul>

            <div className="visit-us-actions">
              <PrimaryButton onClick={onBookTable}>{t.bookTable}</PrimaryButton>
              <button
                type="button"
                className={`btn-secondary visit-us-copy-btn${copied ? " is-copied" : ""}`}
                onClick={handleCopyEmail}
                aria-live="polite"
              >
                <span className="visit-us-copy-btn-label visit-us-copy-btn-label--idle">
                  {t.writeUs}
                </span>
                <span className="visit-us-copy-btn-label visit-us-copy-btn-label--done">
                  {t.emailCopied}
                </span>
              </button>
            </div>
          </div>

          <div className="visit-us-block visit-us-block--map">
            <VisitMap
              title={t.mapTitle}
              openLabel={t.mapOpen}
              address={t.address}
            />
          </div>

          <div className="visit-us-block visit-us-block--contact">
            <ul className="visit-us-contact-list">
              <li>
                <IconPhone className="visit-icon" />
                <a href={phoneHref}>{t.phoneValue}</a>
              </li>
              <li>
                <IconMail className="visit-icon" />
                <button
                  type="button"
                  className="visit-us-copy-email"
                  onClick={handleCopyEmail}
                >
                  {copied ? t.emailCopied : t.emailValue}
                </button>
              </li>
              <li>
                <IconInstagram className="visit-icon" />
                <a href={t.instagramUrl} target="_blank" rel="noreferrer">
                  {t.instagram}
                </a>
              </li>
              <li>
                <IconFacebook className="visit-icon" />
                <a href={t.facebookUrl} target="_blank" rel="noreferrer">
                  {t.facebook}
                </a>
              </li>
            </ul>

            <p className="visit-us-closing">{t.closing}</p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default VisitUsSection;
